module.exports = __webpack_public_path__ + "fonts/StagSans-Book.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Book.ttf
// module id = 1088
// module chunks = 0